const ConfigTypes = [
  [
    ["Lean-To (LT)", "lean-to"],
    ["Flat-Roof (FR) LT", "flatroof-lt"],
    ["Flat-Roof C-Fly", "flat-roof-cfly"],
    ["Back-Wall (BW) LT", "backwall-lt"],
    ["BWFR LT", "bwfr-lt"]
  ],
  [
    ["A-Frame (AF)", "aframe"],
    ["A-Frame LT", "aframe-lt"],
    ["Side-Wall AF", "sidewall-af"],
    ["Tube Tent", "tube-tent"],
    ["A-Frame C-Fly", "aframe-cfly"],
    ["Open Stall", "open-stall"]
  ],
  [
    ["Diamond", "diamond"],
    ["Plow Point", "plow-point"],
    ["Adirondack", "adirondack"],
    ["Hex Diamond", "hex-diamond"],
    ["Arrowhead Wedge", "arrowhead"]
  ],
  [
    ["Side-Wall LT", "sidewall-lt"],
    ["Holden Tent", "holden"],
    ["Miners Tent", "miners"],
    ["Bakers Wind Shed", "bakers"],
    ["Lavvu", "lavvu"]
  ]
];

export default ConfigTypes;
